var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoKrCorner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 86,
    viewBox: "0 0 201 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.301 -21.5556C151.717 -21.5556 150.379 -22 142.795 -22C139.673 -22 136.55 -20.6667 134.766 -18.4444C106.216 15.7778 55.3612 80.2222 55.3612 80.2222C52.6846 83.3333 54.0229 86 58.4838 86H59.8221C69.6361 86 72.3127 83.7778 75.8814 80.6667C75.8814 80.6667 136.996 23.7778 166.884 -6.88889C171.791 -12.6667 167.776 -21.1111 159.301 -21.5556Z",
    fill: "#ED1C24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.924 -21.5556C205.393 -21.5556 204.064 -22 196.533 -22C193.432 -22 190.331 -20.6667 188.559 -18.4444C159.764 15.7778 109.705 80.2222 109.705 80.2222C107.047 83.3333 108.376 86 112.806 86H114.135C123.881 86 126.539 83.7778 130.083 80.6667C130.083 80.6667 190.774 23.7778 220.455 -6.88889C225.328 -12.6667 220.898 -21.1111 212.924 -21.5556Z",
    fill: "#FFC20E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0897 56.6667C67.48 37.5556 94.9624 10.8889 112.25 -6.88889C117.569 -12.2222 113.58 -21.1111 105.158 -21.5556C97.622 -21.5556 96.2923 -22 88.7567 -22C85.6539 -22 82.551 -20.6667 80.7779 -18.4444C67.9232 -3.33333 50.6358 18 35.5648 37.1111L18.7207 58.4445C8.52556 71.3333 1.87657 80.2222 1.87657 80.2222C-0.78303 83.3333 0.546772 86 4.97943 86H6.30923C16.0611 86 18.7207 83.7778 22.2668 80.6667C22.2668 80.6667 24.4831 78.4444 28.4725 74.8889L47.0897 56.6667Z",
    fill: "#58B947"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKrCorner);
export default __webpack_public_path__ + "static/media/logo-kr-corner.2b9b7cae8475f1f97a260761d053c524.svg";
export { ForwardRef as ReactComponent };